export const name = 'fastNavigationManager' as const
export const FastNavigationManagerSymbol = Symbol('FastNavigationManager')
